export default {
  "pl": {
    "message": {
      "actions": {
        "delete_message": "Usuń wiadomość",
        "send": "Wysłane"
      },
      "labels": {
        "cannot_delete_message": "Ta wiadomość została już odczytana przez klienta i nie można jej usunąć.",
        "changes_not_saved": "Masz niezapisane zmiany. Czy na pewno chcesz kontynuować?\nPS: możesz otworzyć nową kartę i przeglądać inne strony w tym samym czasie.",
        "delete_message": "Usuniesz wiadomość dla wszystkich. Pamiętaj, że adresaci mogli otrzymać już powiadomienie e-mail (w zależności od wybranych przez nich ustawień).",
        "delete_message_abort": "Nie można usunąć wiadomości",
        "notSeenYet": "Niewyświetlona",
        "seen_by": "Wyświetlona przez: {participants}"
      },
      "validation": {
        "message_required": "Należy wpisać wiadomość"
      }
    }
  }
}
